import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Modal } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import i18n from 'i18n-js';

const PermissionModal = ({ visible, onAllow, onDeny, isError = false }) => {
  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="fade"
      onRequestClose={onDeny}
    >
      <View style={styles.overlay}>
        <LinearGradient
          colors={isError ? ['#dc3545', '#ff6b7a'] : ['#d47d02', '#ffb636']}
          start={{ x: 0, y: 1 }}
          end={{ x: 0, y: 0 }}
          style={styles.modalContainer}
        >
          <Text style={styles.title}>
            {isError
              ? i18n.t('camScanner.permissionDeniedTitle', { defaultValue: 'Camera Access Denied' })
              : i18n.t('camScanner.permissionTitle', { defaultValue: 'Camera Access Required' })
            }
          </Text>

          <Text style={styles.message}>
            {isError
              ? i18n.t('camScanner.permissionDeniedMessage', {
                  defaultValue: 'Please grant camera access to use the camera scanner.'
                })
              : i18n.t('camScanner.permissionMessage', {
                  defaultValue: 'GroovePacker needs camera access to scan barcodes. This helps you quickly search orders and verify items.'
                })
            }
          </Text>

          <View style={styles.buttonContainer}>
            {!isError && (
              <TouchableOpacity
                style={[styles.button, styles.secondaryButton]}
                onPress={onDeny}
                testID="denyButton"
              >
                <Text style={styles.buttonText}>
                  {i18n.t('camScanner.notNow', { defaultValue: 'Not Now' })}
                </Text>
              </TouchableOpacity>
            )}

            <TouchableOpacity
              style={[styles.button, isError ? styles.errorButton : styles.primaryButton]}
              onPress={isError ? onDeny : onAllow}
              testID={isError ? "closeButton" : "allowButton"}
            >
              <Text style={styles.buttonText}>
                {isError
                  ? i18n.t('camScanner.close', { defaultValue: 'Close' })
                  : i18n.t('camScanner.allow', { defaultValue: 'Allow' })
                }
              </Text>
            </TouchableOpacity>
          </View>
        </LinearGradient>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    width: '85%',
    maxWidth: 400,
    borderRadius: 10,
    padding: 20,
    alignItems: 'center',
  },
  title: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#4b4132',
    marginBottom: 15,
    textAlign: 'center',
  },
  message: {
    fontSize: 16,
    color: '#4b4132',
    marginBottom: 25,
    textAlign: 'center',
    lineHeight: 22,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  button: {
    flex: 1,
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 5,
    marginHorizontal: 5,
    alignItems: 'center',
  },
  primaryButton: {
    backgroundColor: '#4CAF50',
  },
  secondaryButton: {
    backgroundColor: '#757575',
  },
  errorButton: {
    backgroundColor: '#fff',
  },
  buttonText: {
    color: '#080808',
    fontSize: 16,
    fontWeight: 'bold',
  },
});

export default PermissionModal;
